/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.calendar.manual-setup'},
});

const ManualSetupItem = () => (
  <RouteLinkItem
    route="midas/settings/calendar/manual-setup"
    title={messages.title}
  />
);

export default ManualSetupItem;
